export const NAV = {
  init: () => {
    $('#map-switch').on('click', NAV.toggle);
  },
  toggle: function() {
    $('#map-switch').toggleClass('enabled');
    $('#map-nav-items').stop(true,false).slideToggle(200, 'swing')
      .find('.item').on('click', NAV.toggle);
  }
}